var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3379_28817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 35,
    r: 30.5,
    stroke: "#19191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 35C49 35.2652 48.8946 35.5196 48.7071 35.7071C48.5196 35.8946 48.2652 36 48 36H38V46C38 46.2652 37.8946 46.5196 37.7071 46.7071C37.5196 46.8946 37.2652 47 37 47C36.7348 47 36.4804 46.8946 36.2929 46.7071C36.1054 46.5196 36 46.2652 36 46V36H26C25.7348 36 25.4804 35.8946 25.2929 35.7071C25.1054 35.5196 25 35.2652 25 35C25 34.7348 25.1054 34.4804 25.2929 34.2929C25.4804 34.1054 25.7348 34 26 34H36V24C36 23.7348 36.1054 23.4804 36.2929 23.2929C36.4804 23.1054 36.7348 23 37 23C37.2652 23 37.5196 23.1054 37.7071 23.2929C37.8946 23.4804 38 23.7348 38 24V34H48C48.2652 34 48.5196 34.1054 48.7071 34.2929C48.8946 34.4804 49 34.7348 49 35Z",
    fill: "#19191C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3379_28817",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.364706 0 0 0 0 0.458824 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3379_28817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3379_28817",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqExpand);
export default __webpack_public_path__ + "static/media/faqExpand.8d071802a842642cd797885197d697b6.svg";
export { ForwardRef as ReactComponent };